<template>
  <div class="">
    
    <!-- 查询表单 -->
    <div>
      <el-form ref="orderFilterConfigSetForm" :model="orderFilterConfigSetForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="商户">
              <el-select
                clearable
                v-model="orderFilterConfigSetForm.merchantId"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in merchatOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="分类">
              <el-select
                clearable
                v-model="orderFilterConfigSetForm.categoryId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getOrderFilterConfigList">查询</el-button>
            <el-button type="primary" @click="addOrderFilterConfig">添加</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            prop="merchantName"
            label="商户">
          </el-table-column>
          <el-table-column
            prop="categoryName"
            label="分类">
          </el-table-column>
          <el-table-column
            label="品牌">
            <template slot-scope="scope">
            {{scope.row.brandIdListName }}
            </template>
          </el-table-column>
            <el-table-column
            label="机型">
            <template slot-scope="scope">
            {{scope.row.modelIdListName }}
            </template>
          </el-table-column>
          <el-table-column
            label="等级">
            <template slot-scope="scope">
            {{scope.row.gradeIdListName }}
            </template>
          </el-table-column>
          <el-table-column
            label="价格区间">
            <template slot-scope="scope">
            {{ scope.row.minMoney+"-"+scope.row.maxMoney}}
          </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">已启用</span>
              <span v-else>已关闭</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
              <template slot-scope="scope">
                <el-button @click="editorOrderFilterConfig(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="open(scope.row.id)" type="text" size="small" v-if="scope.row.status === 1">开启</el-button>
                <el-button @click="close(scope.row.id)" type="text" size="small" style="color: red;" v-else>关闭</el-button>
                <el-button @click="deleteOrderFilterConfig(scope.row.id)" type="text" size="small" style="color: gray;" v-if="scope.row.merchantId!=0">删除</el-button>
              </template>
          </el-table-column>
      </el-table>
      

      <!-- 分页 -->
      <el-pagination style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal">
      </el-pagination>
    </div>

    <!-- 修改或新建城市经理对话框 -->
    <el-dialog :title="dlgType === 'change' ? '编辑订单筛选设置' : '新建订单筛选设置'" :visible.sync="isDlg" width="700px">
      <div style="margin: 20px;">
        <div>
          <el-form ref="editOrderFilterConfigSetForm" :model="editOrderFilterConfigSetForm" :rules="editorFormRules" label-width="140px">
            <el-form-item label="ID" v-if="dlgType === 'change'">
              <el-input clearable v-model="editOrderFilterConfigSetForm.id" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="分类" prop="categoryId">
              <el-select v-model="editOrderFilterConfigSetForm.categoryId" @change="getGradeList(true)">
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商户" prop="merchantId">
              <el-select clearable
                v-model="editOrderFilterConfigSetForm.merchantId"
                filterable
                remote
                placeholder="请输入关键词"
                reserve-keyword
                :loading="loading">
                <el-option
                  v-for="item in merchatOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          <el-form-item label="品牌">
              <el-select
                    clearable
                    style="width:100%"
                    v-model="tempBrandIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                    @change="getModelListByBrandIds()"
                  >
                    <el-option
                      v-for="item in brandOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
            </el-form-item>
            <el-form-item label="机型">
              <el-select
                    clearable
                    style="width:100%"
                    v-model="tempModelIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                  >
                    <el-option
                      v-for="item in modelList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
            </el-form-item>
         
            <el-form-item label="等级">
              <el-select
                    clearable
                    style="width:100%"
                    v-model="tempGradeIdList"
                    filterable
                    multiple
                    remote
                    placeholder="请输入关键词"
                    reserve-keyword
                  >
                    <el-option
                      v-for="item in queryGradeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
            </el-form-item>
      <el-form-item label="最小金额" prop="minMoney">
        <el-input clearable v-model="editOrderFilterConfigSetForm.minMoney"></el-input>
      </el-form-item>
      <el-form-item label="最大金额" prop="maxMoney">
        <el-input clearable v-model="editOrderFilterConfigSetForm.maxMoney"></el-input>
      </el-form-item>  
      <el-form-item label="发送报价" prop="sendType">
         <el-radio v-model="editOrderFilterConfigSetForm.sendType" :label="0" >发送报价员</el-radio>
         <el-radio v-model="editOrderFilterConfigSetForm.sendType" :label="1">发送机器人</el-radio>
      </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button type="primary" style="margin: 30px 20px;" @click="submitEditor">确定</el-button>
          <el-button style="margin: 10px 20px;" @click="closeEditorDlg">暂不</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
      // 查询数据
      orderFilterConfigSetForm: {
        categoryId: null
      },
      categoryOptions: [],
      merchatOptions:[],
      loading: false,

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      tempGradeIdList:[],
      tempBrandIdList:[],
      tempMerchantIdList:[],
      tempModelIdList:[],
      modelList:[],

      // 新建编辑对话框数据

      isDlg: false,
      editOrderFilterConfigSetForm: {
        id: null,
        categoryId: null,
        priceConditionStatus:0,
        sendType:0,
        gradeIdList: [],
        brandIdList: [],
        modelIdList:[]
      },

      editorFormRules: {
        categoryId: [
          { required: true, message: '请选择分类', trigger: 'change' },
        ],
        merchantId: [
          { required: true, message: '请选择商户', trigger: 'change' },
        ],
        // brandIdList: [
        //   { required: true, message: '请选择品牌', trigger: 'change' },
        // ],
        // modelIdList: [
        //   { required: true, message: '请选择机型', trigger: 'change' },
        // ],
        //  gradeIdList: [
        //   { required: true, message: '请选择等级', trigger: 'change' },
        // ],
        minMoney: [
          { required: true, message: '请输入最小金额', trigger: 'change' },
        ],
         maxMoney: [
          { required: true, message: '请选择最大金额', trigger: 'change' },
        ],
      },
      dlgType: 'change',
      queryGradeList:[],
      brandOptions: [],
    }
  },
  watch:{},
  computed:{},
  methods:{
        // 请求分类列表，提供编辑时选择用
    getSelectOptions(typeKey, optionName, categoryId) {
      let self = this;
      self.$api
        .getClass({
          categoryId: categoryId,
          typeKey: typeKey,
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          if (res.code === 200) {
            self[optionName] = res.data.records;
            if(optionName=='brandOptions'){
              self[optionName].unshift({'id':0,'name':'通用'})
            }
          }
        });
    },
    deleteOrderFilterConfig(id){
      let self = this
        self.$confirm('是否删除').then(() => {
           self.$api.deleteOrderFilterConfig({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getOrderFilterConfigList()
          }
      })
      })
   
    },
    // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },

    handleCurrentChange(val) {
      this.currentPage = val
      // 重新请求订单数据
      this.getOrderFilterConfigList()
    }, 
            //获取品牌下的sku信息
      getModelListByBrandIds() {
      let self = this;
      self.$api
        .getModelListByBrandIds({
          brandIds: self.tempBrandIdList,
        })
        .then((res) => {
          self.modelList = res.data||[];
          self.modelList.unshift({'id':0,'name':'通用'})
        });
    },
    //等级
    getGradeList(val) {
      let self = this;
        this.$api
            .getValidModelGrade({
              categoryId: self.editOrderFilterConfigSetForm.categoryId,
            })
            .then((res) => {
              self.queryGradeList = res.data || [];
              self.queryGradeList.unshift({'id':0,'name':'通用'})
            });
          if(val){
            self.tempGradeIdList=[];
            self.tempBrandIdList=[];
          }
          self.getSelectOptions(
                    'phoneBrand',
                    'brandOptions',
                    self.editOrderFilterConfigSetForm.categoryId
                  ); 
    },

     // 请求商户列表
     getMerchantList(param) {
      let self = this;
      self.$api.getMerchantList({
        merchantLike: param,
        page: 1,
        size: 100000,
      }).then(res => {
        if(res.code === 200) {
          self.merchatOptions = res.data.records
          self.merchatOptions.unshift({'id':0,'name':'通用'})
        }
      
      })
    },

    // 获取门店列表
    getOrderFilterConfigList() {
      let self  = this;
      self.$api.listSearchOrderFilterConfig({
        page: self.currentPage,
        size: self.pageSize,
        merchantId: self.orderFilterConfigSetForm.merchantId,
        categoryId: self.orderFilterConfigSetForm.categoryId || null
      }).then(res => {
        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

    // 添加门店
    addOrderFilterConfig() {
      this.dlgType = 'new'
      this.tempGradeIdList=[];
      this.tempBrandIdList = [];
      this.tempMerchantIdList = [];
      this.editOrderFilterConfigSetForm =  {
        id: null,
        categoryId: null,
        gradeIdList: null,
        priceConditionStatus:0,
        brandSwitchStatus:0,
        gradeSwitchStatus:0,
        sendType:0,
        autoPriceGradeId: null
      }
      this.$nextTick(()=>{
          this.$refs['editOrderFilterConfigSetForm'].clearValidate()
      })
      this.isDlg = true
    },

    // 修改门店
    editorOrderFilterConfig(row) {
      let self = this;
      self.editOrderFilterConfigSetForm=JSON.parse(JSON.stringify(row));
      self.getGradeList(false);
      self.tempGradeIdList = JSON.parse(self.editOrderFilterConfigSetForm.gradeIdList)
      self.tempBrandIdList = JSON.parse(self.editOrderFilterConfigSetForm.brandIdList)
      self.dlgType = 'change'
      this.$nextTick(()=>{
        self.isDlg = true
      })
    },

    // 关闭编辑对话框
    closeEditorDlg() {
      this.isDlg = false
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs['editOrderFilterConfigSetForm'].validate((valid) => {
        if (valid) {
          self.editOrderFilterConfigSetForm.gradeIdList=JSON.stringify(self.tempGradeIdList);
          self.editOrderFilterConfigSetForm.brandIdList=JSON.stringify(self.tempBrandIdList);
          self.editOrderFilterConfigSetForm.merchantIdList=JSON.stringify(self.tempMerchantIdList);
           self.editOrderFilterConfigSetForm.modelIdList=JSON.stringify(self.tempModelIdList);
          if(self.dlgType === 'change') {
            self.$api.updateOrderFilterConfig(self.editOrderFilterConfigSetForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getOrderFilterConfigList()
                this.closeEditorDlg()
              }
            })
          } else {
            self.$api.addOrderFilterConfig(self.editOrderFilterConfigSetForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.getOrderFilterConfigList()
                this.closeEditorDlg()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
     
    },

    // 开启门店
    open(id) {
      let self = this
      this.$api.openOrderFilterConfig(id).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '开启成功',
            type: 'success'
          });
          self.getOrderFilterConfigList()
        }
      })
    },

    // 关闭门店
    close(id) {
      let self = this
      this.$api.closeOrderFilterConfig(id).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '关闭成功',
            type: 'success'
          });
          self.getOrderFilterConfigList()
        }
      })
    },

  },
  created(){
    
  },
  mounted(){
    let self = this;
    self.getOrderFilterConfigList();
    self.getSelectOptions("category", "categoryOptions");
    self.getMerchantList();
  }
}
</script>
<style lang="less" scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>